import React from "react";
import { motion } from "framer-motion";

interface OxigenGraphProps {
  oxygenData?: number[];
  className?: string;
}

const DEFAULT_O2_DATA = [97, 98, 98, 99, 98, 97, 98, 98];

const OxigenGraph: React.FC<OxigenGraphProps> = ({ oxygenData, className }) => {
  const data = oxygenData && oxygenData.length > 0 ? oxygenData : DEFAULT_O2_DATA;
  const lineD = `M0,${100 - (data[0] - 90) * 10} ${data.map((o2, i) => `L${(i + 1) * 12.5},${100 - (o2 - 90) * 10}`).join(" ")}`;
  const areaD = `${lineD} L100,100 L0,100 Z`;

  return (
 <svg viewBox="0 0 100 100" className={ className || "w-full h-full absolute inset-0"}>
                                    <defs>
                                        <linearGradient id="oxygenChartGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                            <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.3" />
                                            <stop offset="100%" stopColor="#00E5FF" stopOpacity="0" />
                                        </linearGradient>
                                        <linearGradient id="oxygenGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                            <stop offset="0%" stopColor="#00E5FF" />
                                            <stop offset="100%" stopColor="#0072CE" />
                                        </linearGradient>
                                    </defs>
                                    <path
                                        d={lineD}
                                        fill="none"
                                        stroke="url(#oxygenGradient)"
                                        strokeWidth="2"
                                    />
                                    <path
                                        d={areaD}
                                        fill="url(#oxygenChartGradient)"
                                    />
                                </svg>
  );
};

export default  OxigenGraph;